export class PACycleLegendsModel {
    constructor() {
        this.stepName = "";
        this.stepStyle = "";
    }
}
export default class PACycleLegends extends PACycleLegendsModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
